import LoginPage from 'containers/LoginPage';
import DashboardPage from 'containers/AUTODashboard';
import SignupPage from 'containers/SignupPages';
import ContactsUtilsPage from 'containers/ContactsUtilsPage';
import PasswordRecoveryPage from 'containers/PasswordRecoveryPages';
import AjoutContractPage from 'containers/AjoutContractPage';
import ReclamationPage from 'containers/ReclamationPage';
import FaqPage from 'containers/FaqPage';
import NotificationsPage from 'containers/NotificationsPage';
import ServicesPage from 'containers/ServicesPage';
import AutoDetailsPage from 'containers/AutoDetailsPage';
import RecoveryLoginPage from 'containers/LoginRecoveryPage';
import CompensationServicesPage from 'containers/CompensationServicesPage';
import DevisPage from 'containers/DevisPage';
import MRHDashboard from 'containers/MRhDashboard';
import MRHDetailsPage from 'containers/MRHDetailsPage';
import EpargnDashboard from 'containers/EpargnDashboard';
import EpargnDetails from 'containers/EpargnDetailsPage';
import SiteMapPage from 'containers/SiteMapPage';
import MyAccountPage from 'containers/MyAccountPage';
import AgentPage from 'containers/AgentPage';
import LegalNoticePage from 'containers/LegalNoticePage';
import LexiquePage from 'containers/LexiquePage';
import CookiesPage from 'containers/CookiesPage';
import ContactUsPage from 'containers/ContactUsPage';
import EpargnPendingVerificationPage from 'containers/EpargnPendingVerificationPage';
import PAGES from 'routes/pages';
import AMCDashboard from 'containers/AMCDashboard';
import ASIDashboard from 'containers/ASIDashboard';
import AmcDetailsPage from 'containers/AmcDetailsPage';
import AsiDetailsPage from 'containers/AsiDetailsPage';
import { hasFeature } from 'features/helpers';
import { FEATURES } from 'features/features';

const PRIVATE = () => [
  {
    path: PAGES.AUTODASHBOARD,
    exact: true,
    component: DashboardPage,
    isVisible: true,
  },
  {
    path: PAGES.ADD_CONTRACT,
    exact: true,
    component: AjoutContractPage,
    isVisible: true,
  },
  {
    path: PAGES.RECLAMATION,
    exact: true,
    component: ReclamationPage,
    isVisible: true,
  },
  {
    path: PAGES.NOTIFICATIONS,
    exact: true,
    component: NotificationsPage,
    isVisible: true,
  },
  {
    path: PAGES.AUTO_DETAILS,
    exact: true,
    component: AutoDetailsPage,
    isVisible: true,
  },
  {
    path: PAGES.CompensationServicesPage,
    exact: true,
    component: CompensationServicesPage,
    isVisible: true,
  },
  {
    path: PAGES.DEVIS_PAGE,
    exact: true,
    component: DevisPage,
    isVisible: true,
  },
  {
    path: PAGES.MRHDASHBOARD,
    exact: true,
    component: MRHDashboard,
    isVisible: true,
  },
  {
    path: PAGES.MRH_DETAILS,
    exact: true,
    component: MRHDetailsPage,
    isVisible: true,
  },
  {
    path: PAGES.EPARGN_DASHBOARD,
    exact: true,
    component: EpargnDashboard,
    isVisible: true,
  },
  {
    path: PAGES.EPARGN_DETAILS,
    exact: true,
    component: EpargnDetails,
    isVisible: true,
  },
  {
    path: PAGES.MY_ACCOUNT,
    exact: true,
    component: MyAccountPage,
    isVisible: true,
  },
  {
    path: PAGES.AGENT,
    exact: true,
    component: AgentPage,
    isVisible: true,
  },
  {
    path: PAGES.AMC_DASHBOARD,
    exact: true,
    component: AMCDashboard,
    isVisible: hasFeature(FEATURES.UNIVERSE_AMC),
  },
  {
    path: PAGES.ASI_DASHBOARD,
    exact: true,
    component: ASIDashboard,
    isVisible: hasFeature(FEATURES.UNIVERSE_ASI),
  },
  {
    path: PAGES.AMC_DETAILS,
    exact: true,
    component: AmcDetailsPage,
    isVisible: hasFeature(FEATURES.UNIVERSE_AMC),
  },
  {
    path: PAGES.ASI_DETAILS,
    exact: true,
    component: AsiDetailsPage,
    isVisible: hasFeature(FEATURES.UNIVERSE_ASI),
  },
];

const PUBLIC = [
  {
    path: PAGES.LOGIN,
    exact: true,
    component: LoginPage,
  },
  {
    path: PAGES.SIGNUP,
    exact: true,
    component: SignupPage,
  },
  {
    path: PAGES.RECOVERY_PASSWORD,
    exact: true,
    component: PasswordRecoveryPage,
  },
  {
    path: PAGES.RECOVERYLOGIN,
    exact: true,
    component: RecoveryLoginPage,
  },
];
const TRANSVERSE = [
  {
    path: PAGES.SITEMAP,
    exact: true,
    component: SiteMapPage,
  },
  {
    path: PAGES.COOKIES,
    exact: true,
    component: CookiesPage,
  },
  {
    path: PAGES.SERVICES,
    exact: true,
    component: ServicesPage,
  },
  {
    path: PAGES.CONTACT_US,
    exact: true,
    component: ContactUsPage,
  },
  {
    path: PAGES.LEGAL_NOTICE,
    exact: true,
    component: LegalNoticePage,
  },
  {
    path: PAGES.LEXIQUE,
    exact: true,
    component: LexiquePage,
  },
  {
    path: PAGES.FAQ,
    exact: true,
    component: FaqPage,
  },
  {
    path: PAGES.CONTACTS,
    exact: true,
    component: ContactsUtilsPage,
  },
  {
    path: PAGES.EPARGN_PENDING_VERIFICATION,
    exact: true,
    component: EpargnPendingVerificationPage,
  },
];

export const ROUTES = {
  PRIVATE,
  PUBLIC,
  TRANSVERSE,
};
